import { ParentProps, createMemo } from 'solid-js'
import Image from '../st-image/st-image';
import styles from './st-image-button.module.css'
import btnStyles from '../st-button/st-button.module.css'

type DefaultSrcType = 'student' | 'view' | 'report'

export class ImageButtonProps {
    label = '';
    tooltip?: string = '';
    showLabel? = false;
    src: string | undefined = '';
    defaultSrc: string | DefaultSrcType = '';
    width = 1;
    height? = 1;
    onClick: (ev: MouseEvent) => void = () => { };
}

export default function ImageButton(props: ImageButtonProps) {
    const defaultSrc = createMemo(() => {
        switch (props.defaultSrc) {
            case 'student': return '';
            case 'view': return '';
            case 'report': return '';
            default: return props.defaultSrc;
        }
    });

    const src = createMemo(() => props.src || defaultSrc());

    return (
        <button type="button" class={`${btnStyles.btn} ${styles['st-image-button']}`}
            data-type="link" aria-label={props.label} onClick={props.onClick}
            use:tooltip={props.tooltip}>
            <Image role="presentation" alt={props.label} src={src()} width={`${props.width}px`} />
        </button>
    );
}

ImageButton.defaultProps = new ImageButtonProps();